export const environment = {
    production: false,
    apiUrl: 'https://jfbr6qsbt5.execute-api.us-east-1.amazonaws.com/Prod/api',
    rawAPI: 'https://jfbr6qsbt5.execute-api.us-east-1.amazonaws.com/Prod',
    startup: 'https://startup.stephubs.com',
    s3_bucket_basepath: 'https://stephubs-images.s3.amazonaws.com',
    landing: 'https://stephubs.com'
};